// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Header_Logo__PGS5i","Icons":"Header_Icons__2C7Op","backColor":"Header_backColor__15Fj4","follow":"Header_follow__3Rk6n"};